export default {
  documentsCheckboxText: {
    en: "By checking the mark you confirmed that you read the document and agree to its terms",
    ja: "マークをチェックすることで、ドキュメントを読み、その条件に同意したことを確認したことになります"
  },
}
